module.exports = __webpack_public_path__ + "media/images/new/icons/money-85496e1f2e24ca80c472d50a12ffccd5.png";